/**
 * System Party Constants
 *
 * These are hardcoded party IDs for essential system infrastructure.
 */
/**
 * SteerFi Party ID
 *
 * This is the default party that all new users are automatically assigned to
 * when they first log in via Keycloak. Users can later be reassigned to their
 * proper party by an admin.
 *
 * This party is created by migration: 1763100000000-RemoveUserAuthFieldsAddKeycloakId
 * and named "SteerFi" by the seed script: seed-steerfi-party.ts
 *
 * Used in:
 * - services/api-server/src/middlewares/keycloak-bearer-auth.middleware.ts (auto-provisioning)
 * - packages/db/src/migrations/1763100000000-RemoveUserAuthFieldsAddKeycloakId.ts (creation)
 * - packages/db/src/seeds/seed-steerfi-party.ts (SteerFi party setup)
 * - packages/db/src/seeds/setup-test-data.ts (verification)
 */
export const STEERFI_PARTY_ID = '11111111-1111-1111-1111-111111111111';
/**
 * SteerBridge Strategies LLC Party ID
 *
 * This is a CLIENT party (BUYER role) used for development and testing purposes.
 * Represents SteerBridge Strategies LLC as a client organization.
 *
 * This party is created by: packages/db/src/seeds/seed-steerbridge-strategies-party-user.ts
 *
 * Used in:
 * - packages/db/src/seeds/seed-steerbridge-strategies-party-user.ts (creation)
 * - packages/db/src/seeds/seed-prospect-module-data.ts (seeding)
 */
export const STEERBRIDGE_STRATEGIES_PARTY_ID = '22222222-2222-2222-2222-222222222222';
//# sourceMappingURL=party-constants.js.map